module.exports = "/_next/static/images/industrialWaterSupply-4b8d5b255689e793801347fff8792282.webp";